/* eslint-disable no-undef */

export default {
	name: "link-customers-to-customer-discount-group",
	props: {
		customerDiscountGroupId:{
			default: null
		}
	},
	data() {
		return {
			customerDiscountGroupCustomers: [],
			unassignedCustomers: [],
			discountGroup: {},
			customerDiscountGroupHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
				{
					text: "Branch Number",
					field: "branchNumber"
				},
				{
					text: "Branch Name",
					field: "branchName"
				}
			],
			assignFilterStateChanged: false,
			unassignedFilterStateChanged: false,
			assignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			unassignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getCompaniesLinkedAndUnlinkedToDiscountGroup(){
			this.loading = true;
			orderService.getCompaniesLinkedAndUnlinkedToDiscountGroup(this.customerDiscountGroupId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.unassignedCustomers = successResponse.data.companiesUnlinkedToDiscountGroup;
						this.customerDiscountGroupCustomers = successResponse.data.companiesLinkedToDiscountGroup;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerGroupDiscountCustomers(){
			this.loading = true;
			let request = {
				discountGroupId: this.customerDiscountGroupId,
				searchQuery: this.assignedFilter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.assignedFilter.activeOrInactiveItems)
			};
			orderService.getCompaniesLinkedToDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.customerDiscountGroupCustomers = successResponse.data.result;
						this.customerDiscountGroupCustomers = dataTableHelper.castFieldValues(this.customerDiscountGroupCustomers);
						this.assignFilterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomersNotAssignedToCustomerGroup(){
			this.loading = true;
			let request = {
				discountGroupId: this.customerDiscountGroupId,
				searchQuery: this.unassignedFilter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.unassignedFilter.activeOrInactiveItems)
			};
			orderService.getCompaniesUnlinkedToDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.unassignedCustomers = successResponse.data.result;
						this.unassignedCustomers = dataTableHelper.castFieldValues(this.unassignedCustomers);
						this.unassignedFilterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDiscountGroup(){
			this.loading = true;
			orderService.getDiscountGroup(this.customerDiscountGroupId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.discountGroup = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterAssignedSearchClicked(){
			this.getCustomerGroupDiscountCustomers();
		},
		onFilterUnassignedSearchClicked() {
			this.getCustomersNotAssignedToCustomerGroup();
		},
		onAssignedActiveInactiveFilterSelected(activeOrInactiveKey){
			this.assignedFilter.activeOrInactiveItems = activeOrInactiveKey;
			this.assignFilterStateChanged = true;
		},
		onUnassignedActiveInactiveFilterSelected(activeOrInactiveKey){
			this.unassignedFilter.activeOrInactiveItems = activeOrInactiveKey;
			this.unassignedFilterStateChanged = true;
		},
		unassignCustomerFromSalesRep(customerId){
			this.newUnassignedCustomers.push(customerId);
			console.log("customerId", customerId);
			for(var i = 0; i < this.customerDiscountGroupCustomers.length; i++){
				if(this.customerDiscountGroupCustomers[i].companyId === customerId){
					this.unassignedCustomers.push(this.customerDiscountGroupCustomers[i]);
					this.customerDiscountGroupCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newAssignedCustomers.length; j++){
				if(this.newAssignedCustomers[j] === customerId){
					this.newAssignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		assignCustomerFromSalesRep(customerId){
			this.newAssignedCustomers.push(customerId);
			console.log("customerId", customerId);
			for(var i = 0; i < this.unassignedCustomers.length; i++){
				if(this.unassignedCustomers[i].companyId === customerId){
					this.customerDiscountGroupCustomers.push(this.unassignedCustomers[i]);
					this.unassignedCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newUnassignedCustomers.length; j++){
				if(this.newUnassignedCustomers[j] === customerId){
					this.newUnassignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$router.go(-1);
		},
		onModalCloseClick() {
			this.$router.go(-1);
		},
		onModalSaveClick(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			let request = {
				discountGroupId: this.customerDiscountGroupId,
				companyIdsToLink: this.newAssignedCustomers,
				companyIdsToUnlink: this.newUnassignedCustomers
			};
			orderService.linkAndUnlinkCompaniesFromDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.showSuccessMessage = true;
						this.successMessage = "Customers Linked To Customer Discount Group Updated Successfully";
						this.loading = false;
						// this.$emit("completedPasswordReset", true);
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = successResponse.data.message;
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			var pageTitle = "Link Customer to Discount Group";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
        this.setBreadcrumbs();
	},
	watch: {
		customerDiscountGroupId:{
			handler: function () {
				if(this.customerDiscountGroupId !== null && this.customerDiscountGroupId !== undefined && this.customerDiscountGroupId !== "" && this.customerDiscountGroupId > 0) {
					this.getDiscountGroup();
					this.getCustomerGroupDiscountCustomers();
					this.getCustomersNotAssignedToCustomerGroup();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
